import SchoolRow from '../schoolRow';
import './style.scss';

function SchoolItem({
  itemsDescription,
  itemSchool,
  getSchoolsInfo,
  backTo,
  isCopScope = false,
  isSocialControlScope = false,
  showFinalizationDate = false
}) {
  const rows = Array.isArray(itemSchool)
    ? itemSchool.flatMap((school) => {
        if (school?.groupInfo) {
          return [school];
        }

        const groups = Array.isArray(school?.groups) ? school.groups : [];
        if (groups.length === 0) {
          return [school];
        }

        return groups.map((group) => ({
          ...school,
          groupInfo: group
        }));
      })
    : [];

  return (
    <div
      className={`items-description-container${
        isCopScope ? ' items-description-container--cop' : ''
      }${
        !isCopScope && !showFinalizationDate
          ? ' items-description-container--without-finalization'
          : ''
      }`}
    >
      <div className='description-container'>
        {itemsDescription.length > 0 &&
          itemsDescription.map((itemDescription, index) => (
            <p key={index}>{itemDescription.name}</p>
          ))}
      </div>
      {rows.map((school, index) => (
        <SchoolRow
          key={`${school?.id ?? 'school'}-${school?.groupInfo?.id ?? index}`}
          school={school}
          backTo={backTo}
          getSchoolsInfo={getSchoolsInfo}
          isCopScope={isCopScope}
          isSocialControlScope={isSocialControlScope}
          showFinalizationDate={showFinalizationDate}
        />
      ))}
    </div>
  );
}

export default SchoolItem;
